// Produktseite (/product/:id): Galerie, Kaufblock, Upsell, Zubehör,
// Erinnerung und technische Daten. Übersetzung von fr/fiche.js — gleiche Schlüssel.
// Die PRODUKTtexte (name, tagline, description, features) kommen aus der
// Datenbank über die API: sie laufen über tp()/tpList(), nie über diese Schlüssel.
export default {
  'fiche.seo.titre': '{nom} — Joyful Reveal',
  'fiche.seo.descriptionDefaut':
    'Das Gender-Reveal-Spiel Joyful Reveal: Quiz in zwei Teams, ein Puzzle zum Zusammenlegen und ein letztes Teil zum Freirubbeln.',
  'fiche.seo.titreIntrouvable': 'Produkt nicht gefunden',
  'fiche.seo.titreErreur': 'Fehler beim Laden',
  'fiche.seo.descriptionErreur': 'Dieses Produkt ist im Shop von Mirum Games nicht mehr erhältlich.',

  'fiche.chargement.produit': 'Produkt wird geladen…',

  'fiche.erreur.introuvableTitre': 'Dieses Pack gibt es nicht mehr',
  'fiche.erreur.erreurTitre': 'Laden nicht möglich',
  'fiche.erreur.introuvableTexte':
    'Vielleicht wurde es ersetzt. Alle unsere Packs finden Sie im Shop.',
  'fiche.erreur.erreurTexte':
    'Die Verbindung zum Server ist fehlgeschlagen. Versuchen Sie es gleich noch einmal.',
  'fiche.erreur.versBoutique': '🛍️ Zum Shop',

  'fiche.ariane.label': 'Navigationspfad',

  'fiche.visuels.boiteAlt':
    'Vorderseite der Joyful-Reveal-Box: zwei Bärchen und das Puzzleteil zum Freirubbeln',
  'fiche.visuels.boiteLegende': 'Die Box',
  'fiche.visuels.dosAlt':
    'Rückseite der Box: die 4 Spielschritte, die Sprachen der Spielregeln und der QR-Code',
  'fiche.visuels.dosLegende': 'Die Rückseite der Box',
  'fiche.visuels.contenuAlt':
    'Inhalt des Pack Premium: die Box, der Fragebogen und die beiden Stoffbeutel',
  'fiche.visuels.contenuLegende': 'Das erhalten Sie',
  'fiche.visuels.pochonsAlt': 'Die beiden Stoffbeutel für die zwei Teams',
  'fiche.visuels.pochonsLegende': 'Die Team-Stoffbeutel',
  'fiche.visuels.grattageAlt': 'Eine Hand rubbelt mit einer Münze das goldene Feld des Puzzles frei: das Wort GIRL erscheint',
  'fiche.visuels.grattageLegende': 'Das Freirubbeln',
  'fiche.visuels.puzzleEncadreAlt':
    'Das fertige Puzzle in einem goldenen Rahmen, auf einem Klavier zwischen zwei Kerzenhaltern',
  'fiche.visuels.puzzleEncadreLegende': 'Das gerahmte Andenken',
  'fiche.visuels.puzzleTableAlt':
    'Das fertige Puzzle in seinem goldenen Rahmen, auf einem Eichentisch',
  'fiche.visuels.puzzleTableLegende': 'Nach der Feier',
  'fiche.visuels.questionnaireAlt':
    'Der auf Karton gedruckte Fragebogen mit den Spalten Team 1, Team 2 und Eltern',
  'fiche.visuels.questionnaireLegende': 'Der gedruckte Fragebogen',
  'fiche.visuels.voir': 'Ansehen: {legende}',

  'fiche.achat.gamme': 'Joyful Reveal — Bärchen',
  'fiche.achat.promesse':
    'Elf Fragen, zwei Teams, ein Rubbelteil — und alle erfahren es im selben Moment.',
  'fiche.achat.remise': '−{n} %',
  'fiche.achat.contenuTitre': 'Das steckt in diesem Pack',
  'fiche.achat.ajouter': '🛒 In den Warenkorb',
  'fiche.achat.indisponible': 'Derzeit nicht verfügbar',
  'fiche.achat.reappro': 'Neue Ware ist unterwegs',
  'fiche.achat.expedition': '📦 Versand aus Belgien innerhalb von 1 bis 2 Werktagen',
  // Muss mit PAYS_LIVRES (frontend/src/lib/zonesLivraison.js) übereinstimmen.
  'fiche.achat.livraison':
    '🚚 Lieferung nach Belgien, Frankreich, Luxemburg, in die Niederlande, nach Deutschland und Spanien — Versandkosten werden beim Bezahlen berechnet',
  'fiche.achat.langue':
    '🇫🇷 Box und Spielregeln auf Französisch (zweisprachige Zusammenfassung Französisch / Englisch auf der Box)',
  'fiche.achat.retour': '↩️ 14 Tage Bedenkzeit',

  'fiche.genre.titre': 'Es ist für…',
  'fiche.genre.fille': 'Mädchen',
  'fiche.genre.garcon': 'Junge',
  'fiche.genre.mixte': 'Mädchen + Junge',
  'fiche.genre.alerte': 'Wählen Sie zuerst Mädchen oder Junge.',
  'fiche.genre.discretion':
    'Niemand außer Ihnen erfährt es: Das Rubbelteil verrät es beim Fest.',
  'fiche.genre.packMixte': '👫 Dieses Pack enthält die Mädchen- und die Jungenversion',
  'fiche.genre.packGarcon': '👦 Jungenversion',
  'fiche.genre.packFille': '👧 Mädchenversion',

  // Satz in 4 Teilen, weil zwei Passagen im JSX fett gesetzt sind:
  // « Für [X mehr] erhalten Sie mit dem [NAME] alles, was … »
  'fiche.upsell.badge': '⭐ Am häufigsten gewählt',
  'fiche.upsell.phraseAvant': 'Für',
  'fiche.upsell.phraseGras': '{prix} mehr',
  'fiche.upsell.phraseMilieu': ' erhalten Sie mit dem',
  'fiche.upsell.phraseApres': 'alles, was das Fest perfekt macht.',
  'fiche.upsell.voir': '{nom} ansehen →',

  'fiche.caracteristiques.joueursLabel': 'Spieler',
  'fiche.caracteristiques.joueursValeur': '2 bis 10',
  'fiche.caracteristiques.dureeLabel': 'Dauer',
  'fiche.caracteristiques.dureeValeur': '≈ 20 Minuten',
  'fiche.caracteristiques.piecesLabel': 'Teile',
  'fiche.caracteristiques.piecesValeur': '11 + 1 zum Freirubbeln',
  'fiche.caracteristiques.ageLabel': 'Alter',
  'fiche.caracteristiques.ageValeur': 'Ab 3 Jahren',

  'fiche.etapes.reglesLien': 'Die vollständigen Spielregeln lesen',
  'fiche.etapes.reglesSuite': '— die 11 Fragen sind dabei, druckfertig.',

  'fiche.accessoires.titreAvec': '🎁 In diesem Pack ist schon alles vorbereitet',
  'fiche.accessoires.titreSans': '🎁 Soll beim Öffnen der Box alles bereitliegen?',
  'fiche.accessoires.introAvec':
    'Sie öffnen die Box, legen den Fragebogen auf den Tisch, jeder nimmt seinen Beutel — und das Spiel beginnt.',
  'fiche.accessoires.introSans':
    'Das Pack Premium ergänzt die drei Extras, die am großen Tag den Unterschied machen:',
  'fiche.accessoires.photoContenuAlt':
    'Der Inhalt des Pack Premium flach ausgelegt: die Box, der gedruckte Fragebogen und die beiden Team-Stoffbeutel',
  'fiche.accessoires.photoContenuLegende':
    'Der gedruckte Fragebogen, die Box und die Beutel — echtes Foto',
  'fiche.accessoires.photoPochonsAlt':
    'Die beiden Stoffbeutel mit Kordelzug, beschriftet mit Team 1 und Team 2',
  'fiche.accessoires.photoPochonsLegende': 'Die Team-Stoffbeutel — echtes Foto',
  'fiche.accessoires.pochonsTitre': 'Zwei Stoffbeutel',
  'fiche.accessoires.pochonsTexte':
    'Beschriftet mit Team 1 und Team 2: Jeder schlägt sich beim Ankommen auf seine Seite, und das Spiel läuft von allein an.',
  'fiche.accessoires.questionnaireTitre': 'Der Fragebogen, schon gedruckt',
  'fiche.accessoires.questionnaireTexte':
    'Die 11 Fragen auf 400-g-Karton, mit den Punktespalten beider Teams — und eine leere Vorlage für Ihre eigenen Fragen.',
  'fiche.accessoires.enveloppeTitre': 'Der Erinnerungsumschlag',
  'fiche.accessoires.enveloppeTexte':
    'Nach dem Fest kommt der ausgefüllte Fragebogen hinein — der Umschlag ist dafür gemacht, hinten an einem Bilderrahmen befestigt zu werden.',
  'fiche.accessoires.decouvrir': '{nom} entdecken →',

  'fiche.souvenir.photoAlt':
    'Das fertige Puzzle, gerahmt und an der Wand eines Babyzimmers aufgehängt',
  'fiche.souvenir.photoLegende':
    'Das Puzzle vom großen Tag — 14 × 21 cm, das Format eines Bilderrahmens',
  'fiche.souvenir.surtitre': 'Und nach dem Fest?',
  'fiche.souvenir.titre': 'Ein Bild bleibt an der Wand',
  // Satz um das fett gesetzte « 14 × 21 cm » herum geteilt (das Maß wird nicht übersetzt).
  'fiche.souvenir.tailleAvant': 'Das fertige Puzzle misst',
  'fiche.souvenir.tailleApres':
    '— genau das Format eines handelsüblichen Bilderrahmens. Viele Eltern rahmen es ein und hängen es ins Kinderzimmer: der Tag, an dem alle die Neuigkeit erfuhren, in einem einzigen Bild.',
  // Satz um das fett gesetzte « den Erinnerungsumschlag » herum geteilt.
  'fiche.souvenir.premiumAvant':
    'Der Fragebogen in diesem Pack ist genau dafür gemacht: das Siegerteam, wer das Teil freigerubbelt hat, das Datum — einmal ausgefüllt, stecken Sie ihn in',
  'fiche.souvenir.premiumEnveloppe': 'den Erinnerungsumschlag',
  'fiche.souvenir.premiumApres':
    ', der hinten am Bilderrahmen befestigt wird. In zehn Jahren öffnen Sie ihn gemeinsam wieder.',
  'fiche.souvenir.upsell':
    'Mit dem Pack Premium stecken Sie den am großen Tag ausgefüllten Fragebogen (Siegerteam, wer freigerubbelt hat, das Datum) in den Erinnerungsumschlag hinten am Bilderrahmen. In zehn Jahren öffnen Sie ihn gemeinsam wieder.',

  'fiche.specs.titre': '📋 Technische Daten',
  'fiche.specs.contenuLabel': 'Inhalt der Box',
  'fiche.specs.contenuValeur': '11 Puzzleteile zum Gewinnen + 1 einzigartiges Rubbelteil',
  'fiche.specs.principeLabel': 'Prinzip',
  'fiche.specs.principeValeur':
    'Quiz in zwei Teams, Puzzle zum Zusammenlegen, Enthüllung zum Schluss durch Freirubbeln',
  'fiche.specs.reglesLabel': 'Spielregeln',
  'fiche.specs.reglesValeur':
    'Auf der Rückseite der Box zusammengefasst, vollständige Fassung online über den QR-Code',
  'fiche.specs.matiereLabel': 'Material',
  'fiche.specs.matiereValeur': 'Karton — Box und Teile',
  'fiche.specs.puzzleLabel': 'Fertiges Puzzle',
  'fiche.specs.puzzleValeur': '14 × 21 cm — das Format eines handelsüblichen Bilderrahmens',
  'fiche.specs.securiteLabel': 'Sicherheit',
  'fiche.specs.securiteValeur':
    'Konform mit CE / EN 71. Kleinteile: nicht geeignet für Kinder unter 3 Jahren',
  'fiche.specs.origineLabel': 'Herkunft',
  'fiche.specs.origineValeur': 'Entwickelt und versendet aus Belgien von Mirum Games',
};
